var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('SimpleModal',{on:{"close":function($event){_vm.show = false}}},[_c('GameStateLog',{attrs:{"game":_vm.game,"playerSelf":_vm.playerSelf}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }